/**
 * @generated SignedSource<<bac129ee4d964aaa1e8e2f6320b1ff5c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespQuickFilters_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbRespQuickFilterDropdown_viewer">;
  readonly " $fragmentType": "SbRespQuickFilters_viewer";
};
export type SbRespQuickFilters_viewer$key = {
  readonly " $data"?: SbRespQuickFilters_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespQuickFilters_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespQuickFilters_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbRespQuickFilterDropdown_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c71566bea2ae5770618990603e7ea285";

export default node;
